import React from 'react';
import { motion } from 'framer-motion';
export function CTABanner() {
  return <section className="relative py-24 md:py-32 overflow-hidden" data-id="element-11">
      {/* Parallax Background */}
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80')] bg-cover bg-center bg-fixed" aria-hidden="true" data-id="element-12" />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-charcoal/70" aria-hidden="true" data-id="element-13" />

      <div className="relative z-10 container mx-auto px-4 md:px-6 text-center" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto" data-id="element-15">
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight mb-6" data-id="element-16">
            Ready to Start Your Project?
          </h2>
          <p className="text-lg md:text-xl text-warmWhite/90 mb-10 font-light" data-id="element-17">
            Get a free, no-obligation estimate today and let's bring your vision
            to life.
          </p>
          <a href="#contact" className="inline-block w-full sm:w-auto bg-gold text-charcoal px-10 py-4 rounded font-semibold text-lg hover:bg-gold/90 transition-colors shadow-lg" data-id="element-18">
            Request Your Free Estimate
          </a>
        </motion.div>
      </div>
    </section>;
}